// analytics.ts
import ReactGA from "react-ga4";

export const initGA = () => {
	try {
		const id = process.env.REACT_APP_GOOGLE_ANALYTICS;
		if (!id) {
			console.warn("Google Analytics ID missing");
			return;
		}
		if (!ReactGA) {
			return console.warn("Attempting to track page view, ReactGA is missing");
		}
		ReactGA.initialize(id);
	} catch (err) {
		console.warn("GA initialization failed:", err);
	}
};

export const trackPageView = (path: string) => {
	if (!ReactGA) {
		return console.warn("Attempting to track page view, ReactGA is missing");
	}
	ReactGA.send({ hitType: "pageview", page: path });
	const adsId = process.env.REACT_APP_GOOGLE_TAG;
	const conversionLabel = process.env.REACT_APP_GOOGLE_PAGE_VIEW_CONVERSION_LABEL;

	if (adsId && conversionLabel && (window as any).gtag) {
		(window as any).gtag("event", "conversion", {
			send_to: `${adsId}/${conversionLabel}`
		});
		console.log(`✅ Page view conversion fired: ${path}`);
	}
};

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
	if (!ReactGA) {
		return console.warn("Attempting to track Event, ReactGA is missing");
	}
	ReactGA.event(eventName, params || {});
};
